<!--
 * @Author: DY
 * @Date: 2024-11-21 14:41:15
 * @LastEditTime: 2025-04-25 17:38:20
 * @Description: 产成品库存列表
 * @FilePath: \ShiMo_Mobile\src\views\storage\manufacturedInventory\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="manufacturedInventory commonListStyles">
            <HeaderNav header-title="产成品库存" left-icon-name="2" right-icon-name="5" :extr="{ leftCallBack: swiperright, rightCallBack: rightClickFun, iconName: 'sm-shaixuan11' }"></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">物料代码：{{ item.material_code }}</span>
                                    </h4>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.stock_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_38@2x.png" alt="">
                                            <span>当前库存：{{ item.volume_current }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <button @click="oprnStorageRecord(item)">
                                            入库记录
                                        </button>
                                        <button @click="oprnOutboundRecord(item)">
                                            出库记录
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <van-popup class="sideslip" v-model="popupShow" position="right" :style="{ width: '80%',height: '100%' }">
                <div class="screen">
                    <van-nav-bar title="筛选" right-text="取消" :style="`height: ${ $getNavHeight() }px;`" @click-right="popupShow = false"></van-nav-bar>
                    <section>
                        <dl>
                            <dt>仓库名称</dt>
                            <dd>
                                <van-field v-model="params.stock_name" placeholder="输入仓库名称"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>物料代码</dt>
                            <dd>
                                <van-field v-model="params.material_code" placeholder="输入物料代码"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>短描述</dt>
                            <dd>
                                <van-field v-model="params.material_short_name" placeholder="输入短描述"></van-field>
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="search">
                            确定
                        </button>
                        <button @click="resetSelect">
                            重置
                        </button>
                    </footer>
                </div>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'manufactured-inventory',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'manufactured-inventory');
        }
        next();
    },
    data() {
        return {
            pageSize: 5,
            tableCode: 'material_stock_list_ccp',
            popupShow: false,
            params: {
                stock_name: '',
                material_code: '',
                material_short_name: '',
            },
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {},
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    methods: {
        rightClickFun() {
            this.popupShow = true;
        },
        loadRequestData() {
            return {
                code: this.tableCode,
                cacheKey: this.cacheKey,
                page: this.pageIndex,
                limit: this.pageSize,
                stock_name: this.params.stock_name,
                material_code: this.params.material_code,
                material_short_name: this.params.material_short_name,
            };
        },
        // 确认筛选
        search() {
            this.listData = [];
            this.pageIndex = 0;
            this.finished = false;
            this.popupShow = false;
            this.initPage();
        },
        // 重置筛选条件
        resetSelect() {
            this.params.stock_name = '';
            this.params.material_code = '';
            this.params.material_short_name = '';
        },
        oprnStorageRecord(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'storageRecord_ccp', params: { data: item } });
        },
        oprnOutboundRecord(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'outboundRecord_ccp', params: { data: item } });
        },
    },
};
</script>
<style lang="stylus"></style>
